import React, { useState } from 'react';
import { SubGroupWrapper } from 'src/components/profileComponents/Marketplace/components/SubGroupWrapper';
import { translations } from 'src/constants/translations';
import { readURL } from 'src/helpers';
import {
  UploadMarketplace,
} from 'src/components/profileComponents/Marketplace/components/Filters/components/UploadMarketplace';
import { IMarketplaceModuleFiltersConfiguration } from 'src/components/profileComponents/Marketplace/types';

interface Props {
  item: IMarketplaceModuleFiltersConfiguration;
  onChange: (item: IMarketplaceModuleFiltersConfiguration) => void,
}

export const AdditionalSettings: React.FC<Props> = ({ item, onChange }) => {
  const [image, setImage] = useState<string | null>(item.tooltipIconUri?.fileUrl || null);
  const onTrash = () => {
    setImage(null);
    onChange({ ...item, tooltipIconUri: null });
  };
  return (
    <SubGroupWrapper
      name={`${translations.additionalSettingsTitle}:`}
      onTrash={onTrash}
    >
      <UploadMarketplace
        register={() => {}}
        registerName=""
        image={image}
        onUpload={async (file, response) => {
          onChange({ ...item, tooltipIconUri: response.data[0] });
          const base64: string = await readURL(file);
          if (base64) {
            setImage(base64);
          }
        }}
      />
    </SubGroupWrapper>
  );
};
